module.exports = __webpack_public_path__ + "static/media/haitao1.f14eef7b.jpg";